<script setup lang="ts">
import { useField } from 'vee-validate';
import { toRef } from 'vue';
import type { VeeNumberFieldProps } from '../types';
import NumberField from '@/components/forms/NumberField/NumberField.vue';
import { useVeeFormProps } from '../utils';

const props = withDefaults(defineProps<VeeNumberFieldProps>(), {
  validateOnValueUpdate: false,
});

const veeProps = useVeeFormProps(props);

const { errorMessage, value, handleChange, handleBlur, meta } = useField<number | undefined>(
  toRef(() => props.name),
  undefined,
  {
    validateOnValueUpdate: props.validateOnValueUpdate,
  },
);

function onUpdate(input: number | undefined) {
  handleChange(input, meta.touched);
}

function onBlur(event: Event) {
  handleBlur(event, true);
}
</script>

<template>
  <NumberField
    v-bind="veeProps"
    :modelValue="value"
    :errorMessage="errorMessage"
    @update:modelValue="onUpdate"
    @blur="onBlur"
  />
</template>
